module.exports = __webpack_public_path__ + "assets/img/SearchBAPC.b938b480.png";